import { useAtom, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import * as React from 'react'
import { createContext, useContext } from 'react'

import { viewTypeAtom } from './AtomUtil'
import { authDataAtom } from '../domains/user/AtomUsers'
import { UNREADY } from '../utils/UIConstant'
import { VIEW_TYPES } from '../utils/utility'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [authData] = useAtom(authDataAtom)
  const setViewType = useSetAtom(viewTypeAtom)

  useEffect(() => {
    if (authData?.user?.roles?.includes('INSTRUCTOR')) {
      setViewType(VIEW_TYPES.INSTRUCTOR)
    }
  }, [authData, setViewType])

  if (authData === UNREADY) {
    return null
  }

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>
}

export const useAuth = () => useContext(AuthContext)
